"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isStorybookOrTest = exports.isE2ETest = exports.isTest = exports.isE2E = exports.isCI = exports.isStorybook = exports.isProduction = exports.envFromBranch = exports.env = exports.branch = exports.branchToNodeEnv = void 0;

/*
 * Copyright (C) 2018-2019 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
var ci = process.env.CI;
var e2e = process.env.E2E;
var storybook = process.env.STORYBOOK_PREVIEW;
/**
 * @param {string} branch
 *
 * @returns {string}
 */

var branchToEnvironment = function branchToEnvironment(branch) {
  switch (branch) {
    case 'master':
      return 'production';

    case 'stage':
      return 'stage';

    default:
      return 'development';
  }
};
/**
 * @param {string} branch
 *
 * @returns {string}
 */


var branchToNodeEnv = function branchToNodeEnv(branch) {
  switch (branch) {
    case 'master':
    case 'stage':
      return 'production';

    default:
      return 'development';
  }
}; // Projects might define current CI branch to enable this feature.


exports.branchToNodeEnv = branchToNodeEnv;
var branch = process.env.BRANCH; // We use `NODE_ENV` to switch the environment.

exports.branch = branch;
var env = process.env.NODE_ENV;
exports.env = env;
var envFromBranch = branchToEnvironment(branch);
exports.envFromBranch = envFromBranch;
var isProduction = env === 'production';
exports.isProduction = isProduction;
var isStorybook = storybook === 'true';
exports.isStorybook = isStorybook;
var isCI = ci === 'true';
exports.isCI = isCI;
var isE2E = e2e === 'true';
exports.isE2E = isE2E;
var isTest = env === 'test';
exports.isTest = isTest;
var isE2ETest = isTest && isE2E;
exports.isE2ETest = isE2ETest;
var isStorybookOrTest = isStorybook || isTest;
exports.isStorybookOrTest = isStorybookOrTest;